import './App.css';
import TopNav from './Components/TopNav/TopNav';
import NavBar from './Components/NavBar/NavBar';
import Carousel from './Components/Slider/Slider';
import SmallCard from './Components/SmallCard/SmallCard';
import ContCard from './Components/ConCards/ContCard';
import LargeCards from './Components/LargeCards/LargeCards';
import FirstSlider from './Components/FirstSlider/FirstSlider';
import ModalTest from './Components/ModalTest/ModalTest.jsx';
import SecondSlider from './Components/SecondSlider/SecondSlider';
import EndFooter from './Components/EndFooter/EndFooter';
import STSNetwork from './Components/STSNetwork/STSNetwork';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <>
      <TopNav />
      <NavBar />
      <Carousel />
      <SmallCard />
      <ContCard />
      <LargeCards />
      <FirstSlider />
      <STSNetwork />
      <ModalTest />
      <SecondSlider />
      <Footer />
      <EndFooter />
    </>
  );
}

export default App;
